import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy di DeskStudio
      </Typography>

      <Typography variant="subtitle2" gutterBottom>
        Ultimo aggiornamento: 20 Marzo 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">1. Raccolta dei dati</Typography>
        <Typography paragraph>
          Raccogliamo i dati personali necessari per l’utilizzo della piattaforma, tra cui:
        </Typography>
        <ul>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Credenziali di accesso (password cifrata)</li>
          <li>Dati relativi a documenti e scadenze</li>
          <li>Dati tecnici e di utilizzo (log, analytics)</li>
        </ul>

        <Typography variant="h6">2. Finalità del trattamento</Typography>
        <Typography paragraph>
          I dati vengono utilizzati per:
        </Typography>
        <ul>
          <li>Fornire e gestire il servizio</li>
          <li>Gestione documenti e scadenze</li>
          <li>Autenticazione e sicurezza</li>
          <li>Invio notifiche e comunicazioni</li>
          <li>Analisi anonime per miglioramento del servizio</li>
        </ul>

        <Typography variant="h6">3. Base giuridica</Typography>
        <Typography paragraph>
          Il trattamento si basa su:
        </Typography>
        <ul>
          <li>Esecuzione del servizio richiesto</li>
          <li>Obblighi legali</li>
          <li>Legittimo interesse del Titolare</li>
        </ul>

        <Typography variant="h6">4. Conservazione dei dati</Typography>
        <Typography paragraph>
          I dati vengono conservati per il tempo necessario all’erogazione del servizio o fino a richiesta di cancellazione, salvo obblighi di legge.
        </Typography>

        <Typography variant="h6">5. Condivisione dei dati</Typography>
        <Typography paragraph>
          I dati non vengono venduti. Possono essere condivisi con fornitori tecnici necessari al funzionamento del servizio, come:
        </Typography>
        <ul>
          <li>Provider di hosting</li>
          <li>Servizi di analisi (es. Google Analytics in forma anonima)</li>
        </ul>

        <Typography variant="h6">6. Diritti dell’utente</Typography>
        <Typography paragraph>
          L’utente ha diritto di:
        </Typography>
        <ul>
          <li>Accedere ai propri dati</li>
          <li>Rettificarli o aggiornarli</li>
          <li>Richiederne la cancellazione</li>
          <li>Opporsi al trattamento</li>
        </ul>

        <Typography paragraph>
          Per esercitare i diritti: <strong>info@deskstudio.it</strong>
        </Typography>

        <Typography variant="h6">7. Sicurezza</Typography>
        <Typography paragraph>
          Adottiamo misure tecniche e organizzative adeguate per proteggere i dati da accessi non autorizzati, perdita o uso improprio.
        </Typography>

        <Typography variant="h6">8. Contatti</Typography>
        <Typography paragraph>
          Per qualsiasi informazione: <strong>info@deskstudio.it</strong>
        </Typography>
      </Box>

      <BackButtonDesktop />
    </Container>
  );
}